
































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
})
export default class Navbar extends Vue {
  public isActive = false;

  public toggle() {
    this.isActive ? this.hide() : this.show();
  }

  public show() {
    this.isActive = true;
  }

  public hide() {
    this.isActive = false;
  }

  @Watch('$route')
  public onRouteChange() {
    this.hide();
  }
}
